import { screeningAction } from '../../actions/constant';

const {
  GET_FORM_ID_FOR_SCREENING_REQUEST,
  GET_FORM_ID_FOR_SCREENING_SUCCESS,
  GET_FORM_ID_FOR_SCREENING_FAILURE,
  GET_FORM_ID_FOR_SCREENING_LOADER,
} = screeningAction;

const intitialstate: object = {
  response: null,
  isFormId: false,
  loader: false,
};

export const getFormIdForScreeningReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_FORM_ID_FOR_SCREENING_SUCCESS: {
      return {
        ...state,
        isFormId: true,
        response: action.payload?.data,
        loader: false,
      };
    }

    case GET_FORM_ID_FOR_SCREENING_FAILURE:
      return {
        ...state,
        isFormId: false,
        response: action.payload,
        loader: false,
      };
    case GET_FORM_ID_FOR_SCREENING_LOADER:
      return {
        ...state,
        loader: true,
      };

    default:
      return state;
  }
};
